import { dayjs } from '@shared/utils';

export function formatDuration(seconds: number): string {
  if (seconds === 0) return '-';

  const d = dayjs.duration(seconds, 'seconds');

  const hours = Math.floor(d.asHours());
  const minutes = d.minutes();

  if (hours > 0 && minutes > 0) {
    return `${hours} ชั่วโมง ${minutes} นาที`;
  }

  if (hours > 0) {
    return `${hours} ชั่วโมง`;
  }

  return `${minutes} นาที`;
}

export function formatTime(date: Date): string {
  return `${dayjs(date).format('HH:mm')} น.`;
}

export function formatMillisecondsToMinutesSeconds(
  ms: number | null | undefined,
): { minutes: string; seconds: string } | null {
  if (ms == null) return null;

  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes: String(minutes), seconds: String(seconds).padStart(2, '0') };
}
